import { inject, provideEnvironmentInitializer } from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { AgendaRepository } from './repositories/agenda.repository';
import { GarageOrderItemRepository } from './repositories/garage-order-item.repository';
import { GarageOrderRepository } from './repositories/garage-order.repository';
import { MechanicRepository } from './repositories/mechanic.repository';
import { MileageHistoryRepository } from './repositories/mileage-history.repository';
import { NotificationRepository } from './repositories/notification.repository';
import { OrderNotesRepository } from './repositories/order-notes.repository';
import { PrintRepository } from './repositories/print.repository';
import { ProductOrderItemRepository } from './repositories/product-order-item.repository';
import { ProductOrderRepository } from './repositories/product-order.repository';
import { ScanRepository } from './repositories/scan.repository';
import { ItemScanRepository } from './repositories/item-scan.repository';
import { TaskRepository } from './repositories/task.repository';
import { TimeReportRepository } from './repositories/time-report.repsitory';
import { MechanicService } from './services/mechanic.service';
import { MileageHistoryService } from './services/mileage-history.service';
import { NotificationService } from './services/notification.service';
import { OrderService } from './services/order.service';
import { ScanService } from './services/scan.service';
import { ItemScanService } from './services/item-scan.service';
import { TaskService } from './services/task.service';

export const provideGarageCore = () => [
  provideEnvironmentInitializer(() => {
    inject(Store).commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'garage-core',
      language: 'de',
      translations: de,
    });
  }),
  { provide: NotificationService, useFactory: () => new NotificationService() },
  { provide: NotificationRepository, useFactory: () => new NotificationRepository() },
  { provide: OrderService, useFactory: () => new OrderService() },
  { provide: GarageOrderRepository, useFactory: () => new GarageOrderRepository() },
  { provide: ProductOrderRepository, useFactory: () => new ProductOrderRepository() },
  { provide: TaskService, useFactory: () => new TaskService() },
  { provide: TaskRepository, useFactory: () => new TaskRepository() },
  { provide: MechanicService, useFactory: () => new MechanicService() },
  { provide: MechanicRepository, useFactory: () => new MechanicRepository() },
  { provide: TimeReportRepository, useFactory: () => new TimeReportRepository() },
  { provide: MileageHistoryRepository, useFactory: () => new MileageHistoryRepository() },
  {
    provide: GarageOrderItemRepository,
    useFactory: () => new GarageOrderItemRepository(),
  },
  {
    provide: ProductOrderItemRepository,
    useFactory: () => new ProductOrderItemRepository(),
  },
  { provide: PrintRepository, useFactory: () => new PrintRepository() },
  { provide: MileageHistoryService, useFactory: () => new MileageHistoryService() },
  { provide: AgendaRepository, useFactory: () => new AgendaRepository() },
  { provide: OrderNotesRepository, useFactory: () => new OrderNotesRepository() },
  { provide: ScanService, useFactory: () => new ScanService() },
  { provide: ScanRepository, useFactory: () => new ScanRepository() },
  { provide: ItemScanService, useFactory: () => new ItemScanService() },
  { provide: ItemScanRepository, useFactory: () => new ItemScanRepository() },
];
